module.exports = __webpack_public_path__ + "static/media/mens_hat.57a3c1fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/mens_hat.png
// module id = 31
// module chunks = 0